<!-- TODO: Show names instead of id's-->
@for (kv of valueSg() | keyvalue; track kv.key) {
  {{ kv.key }}: {{ kv.value }}
}
